"use client"

import { CreditCard, Percent, ShoppingCart, Trophy } from "lucide-react"
import { useTranslations } from "next-intl"
import { useEffect, useState } from "react"

import { Separator } from "@/components/ui/separator"

export default function SpectraExperience() {
  const [isDesktop, setIsDesktop] = useState(false)
  const t = useTranslations("landing")

  useEffect(() => {
    setIsDesktop(window.matchMedia("(min-width: 768px)").matches)
  }, [])

  const step1 = (
    <div className="flex min-h-40 flex-col items-center">
      <div className="mb-4 rounded-full bg-gray-100 p-2">
        <Percent className="size-8" />
      </div>
      <h3 className="mb-2 text-xl font-semibold text-green-600">{t("experience.steps.1.title")}</h3>
      <p className="text-gray-600">{t("experience.steps.1.description")}</p>
    </div>
  )

  const step2 = (
    <div className="flex min-h-40 flex-col items-center">
      <div className="mb-4 rounded-full bg-gray-100 p-2">
        <ShoppingCart className="size-8" />
      </div>
      <h3 className="mb-2 text-xl font-semibold text-green-600">{t("experience.steps.2.title")}</h3>
      <p className="text-gray-600">{t("experience.steps.2.description")}</p>
    </div>
  )

  const step3 = (
    <div className="flex min-h-40 flex-col items-center md:pt-16">
      <div className="mb-4 rounded-full bg-gray-100 p-2">
        <CreditCard className="size-8" />
      </div>
      <h3 className="mb-2 text-xl font-semibold text-green-600">{t("experience.steps.3.title")}</h3>
      <p className="text-gray-600">{t("experience.steps.3.description")}</p>
    </div>
  )

  const step4 = (
    <div className="flex min-h-40 flex-col items-center md:pt-16">
      <div className="mb-4 rounded-full bg-gray-100 p-2">
        <Trophy className="size-8" />
      </div>
      <h3 className="mb-2 text-xl font-semibold text-green-600">{t("experience.steps.4.title")}</h3>
      <p className="text-gray-600">{t("experience.steps.4.description")}</p>
    </div>
  )

  return (
    <section className="mx-auto flex min-h-screen max-w-6xl flex-col items-center justify-center px-4 pb-16 text-center md:py-0">
      <h1 className="mb-4 text-4xl font-bold md:text-5xl">{t("experience.mainTitle")}</h1>
      <p className="mx-auto mb-16 max-w-3xl text-lg">{t("experience.mainDescription")}</p>

      <h2 className="mb-12 text-3xl font-bold md:text-4xl">{t("experience.sectionTitle")}</h2>

      <div className="flex flex-col divide-gray-200 md:flex-row md:divide-x md:divide-y-0">
        <div className="relative flex-1 space-y-16 md:space-y-8 md:pr-8">
          {step1}
          {isDesktop && <Separator className="absolute inset-x-0 my-8" />}
          {isDesktop ? step3 : step2}
        </div>

        <div className="relative mt-16 flex-1 space-y-16 md:mt-0 md:space-y-8 md:pl-8">
          {isDesktop ? step2 : step3}
          {isDesktop && <Separator className="absolute inset-x-0 my-8" />}
          {step4}
        </div>
      </div>
    </section>
  )
}
